import actionTypes from '../constants/actionTypes';

export const startGetSubsection = () => ({
  type: actionTypes.START_GET_SUBSECTION,
});

export const successGetSubsection = (subsection) => ({
  type: actionTypes.SUCCESS_GET_SUBSECTION,
  subsection,
});

export const errorGetSubsection = (error) => ({
  type: actionTypes.ERROR_GET_SUBSECTION,
  error,
});

export const getSubsection = (subsectionLink) => {
  return async (dispatch) => {
    dispatch(startGetSubsection());
    try {
      const [subsection] = await (
        await fetch(
          `${process.env.REACT_APP_ENDPOINT}/subsections?link=${subsectionLink}`
        )
      ).json();
      dispatch(successGetSubsection(subsection));
    } catch (error) {
      dispatch(errorGetSubsection(error));
    }
  };
};
